import { useCallback } from "react";

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from "@/analytics";
import {
    ActionKey,
    ActionSubjectKey,
    ActionSubjectIdKey
} from "@/analytics/constants";

export const useCustomerSelectionUIAnalytics = () => {
    const { sourceKey, identityAttrs } = useFastshiftAnalyticsData();
    const { fireUIEvent } = useFireAnalyticsEvents(identityAttrs);

    // UI event callbacks
    const sendSeeDetailsClickUIEvent = useCallback(
        (selectedCustomerDomain: string, selectedCustomerDomainId: string) => {
            fireUIEvent({
                action: ActionKey.CLICKED,
                actionSubject: ActionSubjectKey.LINK,
                actionSubjectId: ActionSubjectIdKey.SEE_DETAILS_BUTTON,
                source: sourceKey,
                attributes: {
                    selectedCustomerDomain,
                    selectedCustomerDomainId
                }
            });
        },
        [fireUIEvent, sourceKey]
    );

    return {
        sendSeeDetailsClickUIEvent
    };
};
